import {Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {Actions} from '@ngrx/effects';
import { AppState } from '../../..';


@Injectable()
export class InstitutionEffects {


  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
  ) { }

}
